module.exports = __webpack_public_path__ + "static/010-d558644cc944fd1bd985ffa6e6e6213b.jpg";